import { render, staticRenderFns } from "./CompanyInterfaceSettings.vue?vue&type=template&id=66d059e1&scoped=true"
import script from "./CompanyInterfaceSettings.vue?vue&type=script&lang=ts"
export * from "./CompanyInterfaceSettings.vue?vue&type=script&lang=ts"
import style0 from "./CompanyInterfaceSettings.vue?vue&type=style&index=0&id=66d059e1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d059e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66d059e1')) {
      api.createRecord('66d059e1', component.options)
    } else {
      api.reload('66d059e1', component.options)
    }
    module.hot.accept("./CompanyInterfaceSettings.vue?vue&type=template&id=66d059e1&scoped=true", function () {
      api.rerender('66d059e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/CompanyInterfaceSettings.vue"
export default component.exports